export function getSimpleKeyboardLayout() {
	// TODO: here we can return the layouts for the specific languages
	return {
		'default':[
			'1 2 3 4 5 6 7 8 9 {bksp}',
			'q w e r t y u i o p Clear.',
			'{lock} a s d f g h j k l',
			'{shift} z x c v b n m {enter}',
			'{space}'
		],
		'shift':[
			'1 2 3 4 5 6 7 8 9 {bksp}',
			'Q W E R T Y U I O P Clear.',
			'{lock} A S D F G H J K L',
			'{shift} Z X C V B N M {enter}',
			'{space}'
		]

	}
}
